export default {
  mini: false,
  navigationRules: {},
  customMenuItems: {},
  disabledMenuItems: []
}
